const arr = [
  '/static/images/headImg/0.jpg',
  '/static/images/headImg/1.jpg',
  '/static/images/headImg/2.jpg',
  '/static/images/headImg/3.jpg',
  '/static/images/headImg/4.jpg',
  '/static/images/headImg/5.jpg',
  '/static/images/headImg/6.jpg',
  '/static/images/headImg/7.jpg',
];

export default arr;



// WEBPACK FOOTER //
// ./src/mock/headImg.config.js